import script from "./Iac.vue?vue&type=script&setup=true&lang=js"
export * from "./Iac.vue?vue&type=script&setup=true&lang=js"

import "./Iac.vue?vue&type=style&index=0&id=6f7f9bb9&lang=scss"

const __exports__ = script;

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QPageSticky});
